import { EventMeta } from '../../../interfaces/meta.interface';
import { riskyWords } from '../../utils/riskWords';

type MailItemsAccessedFields = {
    riskyKeyword: boolean;
};

function mailboxOperations(log: any) {
    return {
        loginType: log.InternalLogonType,
        internalLoginType: log.LogonType,
        result: log.OperationResult,
        externalAccess: log.ExternalAccess,
        owner: log.MailboxOwnerUPN,
        client: log.ClientInfoString,
        riskyKeyword:
            !!log.AffectedItems && !!log.AffectedItems[0]['Subject']
                ? riskyWords.some((word) => log.AffectedItems[0]['Subject'].toLowerCase().includes(word.toLowerCase()))
                : false,
    };
}

const create: EventMeta<MailItemsAccessedFields, { item: string; folder: string }> = {
    title: 'Mail Item Created',
    default: {
        description: 'Mail Item Created',
        longDescription: 'An item was created in the Calendar, Contacts, Notes, or Tasks folder in the mailbox.',
        severity: 'info',
    },
    fieldsExtractor: mailboxOperations,
    descriptionExtractor: (log: any) => {
        let item;
        if (log.Item && log.Item.Subject) {
            item = log.Item.Subject;
        } else if (log.ItemSubject) {
            item = log.ItemSubject;
        }

        let folder;
        if (log.Item && log.Item.ParentFolder && log.Item.ParentFolder.Path) {
            folder = log.Item.ParentFolder.Path;
        } else if (log.FolderPathName) {
            folder = log.FolderPathName;
        }

        return { item, folder };
    },
    classifications: [
        {
            severity: 'info',
            description: (fields) => {
                if (fields.item) {
                    return `An item named "${fields.item}" was created in "${fields.folder}" folder`;
                } else {
                    return `An item was created in the "${fields.folder}" folder`;
                }
            },
            longDescription: (fields) =>
                `A mail item was created in the "${fields.folder}" folder, which may be routine or could indicate unexpected additions depending on the folder and user.`,
        },
    ],
};

export default create;
